module.exports = __webpack_public_path__ + "img/dual_display_marketing.7e74f214.jpg";